import { useI18n } from '@/context/I18nContext';

interface StatusModalProps {
    isOpen: boolean;
    message: string;
    onClose: () => void;
    title: string;
}

function StatusModal({ isOpen, message, onClose, title }: StatusModalProps) {
    const { t } = useI18n();

    if (!isOpen) {
        return null;
    }

    return (
        <div
            className="modal modal-open"
            role="dialog"
            aria-modal="true"
            aria-labelledby="status-modal-title"
        >
            <div className="modal-box max-w-xl">
                <div className="mb-4 flex items-start justify-between gap-4">
                    <h2 id="status-modal-title">{title}</h2>
                    <button
                        type="button"
                        className="btn btn-ghost btn-sm btn-circle"
                        aria-label={t('Close')}
                        onClick={onClose}
                    >
                        ✕
                    </button>
                </div>

                <p>{message}</p>

                <div className="modal-action">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={onClose}
                    >
                        {t('OK')}
                    </button>
                </div>
            </div>
            <div className="modal-backdrop bg-black/40" onClick={onClose} />
        </div>
    );
}

export default StatusModal;
